<template>
  <div class="fpass-container">
    <div class="fpassword">
      <h2>بازیابی رمز عبور</h2>
      <form @submit.prevent="submit" class="input">
        <div class="tabs">
          <button
            type="button"
            class="tab"
            :class="{ active: forgetPassType === 'SMS' }"
            @click="forgetPassType = 'SMS'"
          >
            ورود با موبایل
          </button>
          <button
            type="button"
            class="tab"
            :class="{ active: forgetPassType === 'EMAIL' }"
            @click="forgetPassType = 'EMAIL'"
          >
            ورود با ایمیل
          </button>
        </div>
        <div v-if="forgetPassType === 'SMS'" class="input-container">
          <span class="input-span"> شماره موبایل </span>
          <label class="no-just" for="mobileNumber">
            <input
              v-model="phone"
              type="text"
              name="mobile"
              style="text-align: left !important; width: 100%"
              max="11"
            />
          </label>
        </div>
        <div v-else-if="forgetPassType === 'EMAIL'" class="input-container">
          <span class="input-span"> ایمیل </span>
          <label class="no-just" for="email">
            <img src="../../assets/icons/darkEmail.svg" alt="" />
            <input
              v-model="email"
              type="email"
              name="email"
              style="text-align: left !important; width: 100%"
            />
          </label>
        </div>
        <!-- <img src="../../assets/recaptcha.svg" alt=""> -->
        <button
          type="submit"
          :disabled="
            forgetPassType === 'SMS'
              ? !$validMobile(phone)
              : !$validEmail(email)
          "
          class="submit"
        >
          ارسال کد بازیابی
        </button>
      </form>
    </div>
  </div>
</template>
<script>
// const goto = {
//   EMAIL: "/RESET-PASS-EMAIL",
//   SMS: "/RESET-PASS-SMS",
//   GOOGLE_AUTHENTICATOR: "/otpforgetpass/GOOGLE_AUTHENTICATOR",
// };
export default {
  name: "ForgetPass",
  data() {
    return {
      email: "",
      phone: "",

      forgetPassType: this.$route.query.type || "EMAIL",
    };
  },
  methods: {
    async submit() {
      this.state.loading = true;
      let body = {};
      if (this.forgetPassType == "EMAIL") {
        body.email = this.email;
        body.authenticationType = "EMAIL";
        this.state.userInfo.email = this.email;
        this.$cookies.set("username", this.email);
      } else {
        body.mobileNumber = this.mobileNumber;
        body.authenticationType = "SMS";
        this.$cookies.set("username", this.mobileNumber);
      }
      await this.$axios.post("/users/forget-password", body);
      await this.$router.push("/newpass");
    },
  },
  computed: {
    mobileNumber() {
      return "+98" + this.phone.slice(1, 11);
    },
  },
};
</script>

<style lang="scss" scoped>
.fpass-container {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  align-self: flex-start;
  margin-top: 140px;
  justify-self: center;
  width: 100%;
  align-items: center;
  justify-content: center;
  @media (max-width: 992px) {
    margin-top: -40px;
  }
}
.input {
  z-index: 5;
  display: flex;
  flex-direction: column;
  padding: 24px;
  row-gap: 32px;
  background: var(--box);
  border-radius: 12px;
}
.fpassword {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  width: 30%;
}
h2 {
  z-index: 5;
  font-family: "sepahbod";
  color: var(--purple-title);
}
@media only screen and (max-width: 1300px) {
  .fpassword {
    width: 50%;
  }
}
@media only screen and (max-width: 1100px) {
  .fpassword {
    width: 70%;
  }
}
@media only screen and (max-width: 900px) {
  .fpassword {
    width: 85%;
  }
}
@media only screen and (max-width: 600px) {
  .fpassword {
    width: 100%;
  }
}
.tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  .tab {
    width: 100px;
    height: 48px;
    color: var(--grey);
    transition: all ease 0.1s;
    background-color: var(--light-grey);
    &:first-child {
      border-radius: 0 12px 12px 0;
    }
    &:last-child {
      border-radius: 12px 0 0 12px;
    }

    &.active {
      border-bottom: 2px solid var(--primary-color);
      color: var(--primary-color);
    }
  }
}
</style>
